import getSelection from '../../accessors/get-selection';

const insertBreakOnReturn = (e) => {
  if (e.key !== 'Enter' || !e.srcElement.hasAttribute('contenteditable')) {
    return;
  }

  e.preventDefault();
  const { ownerDocument: liveDocument } = e.target;

  const wrapper = liveDocument.createElement('div');
  const breakElement = liveDocument.createElement('br');
  wrapper.appendChild(breakElement);
  const selection = getSelection();
  const { focusNode, focusOffset } = selection;
  const atEndOfTextNode = focusNode.textContent.length === focusOffset;

  if (atEndOfTextNode) {
    // Required to create a new line when at the end of text node
    const nonBreakingSpace = liveDocument.createTextNode('\u00a0');
    wrapper.appendChild(nonBreakingSpace);
  }

  liveDocument.execCommand('insertHTML', false, wrapper.innerHTML);

  // Set caret before the non-breaking space after inseration of our wrapper
  // html. This prevents users from having to hit backspace twice when at the
  // end of the contenteditable.
  if (atEndOfTextNode) {
    const postInsertionRange = getSelection().getRangeAt(0);
    postInsertionRange.setStartBefore(postInsertionRange.commonAncestorContainer);
    postInsertionRange.collapse(true);
  }
};

export default insertBreakOnReturn;
